import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { FiPhone } from 'react-icons/fi';
import { DIAL_CODES, getDialEntry, parsePhoneValue, PHONE_ERROR_MESSAGE } from '../../utils/dialCodes';

const PhoneSegment = ({ phone, onPhoneChange, phoneError, onFocus, dialCountryCode, onDialCountryCodeChange }) => {
  const [open, setOpen] = useState(false);
  const [dropdownStyle, setDropdownStyle] = useState({});
  const [errorStyle, setErrorStyle] = useState({});
  const wrapperRef = useRef(null);
  const dialBtnRef = useRef(null);
  const dropdownRef = useRef(null);

  const selected = getDialEntry(dialCountryCode);
  const digits = parsePhoneValue(phone, selected);

  // Posiciona el dropdown con position:fixed (via portal) para escapar de
  // cualquier overflow:hidden de la barra de búsqueda.
  useEffect(() => {
    if (!open || !dialBtnRef.current) return;

    const updatePosition = () => {
      const rect = dialBtnRef.current.getBoundingClientRect();
      setDropdownStyle({ top: rect.bottom + 6, left: rect.left });
    };

    updatePosition();
    window.addEventListener('resize', updatePosition);
    window.addEventListener('scroll', updatePosition, true);
    return () => {
      window.removeEventListener('resize', updatePosition);
      window.removeEventListener('scroll', updatePosition, true);
    };
  }, [open]);

  // Mismo problema de overflow:hidden aplica al mensaje de error — se
  // posiciona con position:fixed (via portal) igual que el dropdown.
  useEffect(() => {
    if (!phoneError || !wrapperRef.current) return;

    const updatePosition = () => {
      const rect = wrapperRef.current.getBoundingClientRect();
      setErrorStyle({ top: rect.bottom + 6, left: rect.left });
    };

    updatePosition();
    window.addEventListener('resize', updatePosition);
    window.addEventListener('scroll', updatePosition, true);
    return () => {
      window.removeEventListener('resize', updatePosition);
      window.removeEventListener('scroll', updatePosition, true);
    };
  }, [phoneError]);

  useEffect(() => {
    const handleClick = (e) => {
      if (
        wrapperRef.current && !wrapperRef.current.contains(e.target) &&
        dropdownRef.current && !dropdownRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  const handleSelectCode = (entry) => {
    setOpen(false);
    if (onDialCountryCodeChange) onDialCountryCodeChange(entry.code);
    onPhoneChange(entry.dialCode + digits);
  };

  const handleDigitsChange = (e) => {
    const raw = e.target.value.replace(/[^\d\s\-()]/g, '');
    onPhoneChange(selected.dialCode + raw);
  };

  return (
    <div
      className={`sf-searchbar__segment sf-searchbar__segment--phone ${phoneError ? 'sf-searchbar__segment--error' : ''}`}
      ref={wrapperRef}
    >
      <span className="sf-searchbar__segment-icon">
        <FiPhone />
      </span>
      <div className="sf-searchbar__segment-text">
        <label className="sf-searchbar__segment-label">TELÉFONO</label>
        <div className="sf-searchbar__phone-row">
          <button
            type="button"
            ref={dialBtnRef}
            className="sf-searchbar__dialcode-btn"
            onClick={(e) => { e.stopPropagation(); setOpen(prev => !prev); }}
          >
            <span className="sf-searchbar__dialcode-flag">{selected.flag}</span>
            <span className="sf-searchbar__dialcode-code">{selected.dialCode}</span>
          </button>
          <input
            type="tel"
            className="sf-searchbar__segment-value sf-searchbar__segment-input"
            placeholder="300 123 4567"
            value={digits}
            onChange={handleDigitsChange}
            onFocus={onFocus}
          />
        </div>
      </div>

      {open && ReactDOM.createPortal(
        <div
          ref={dropdownRef}
          className="sf-searchbar__dialcode-dropdown"
          style={{ position: 'fixed', zIndex: 999999, ...dropdownStyle }}
        >
          {DIAL_CODES.map(entry => (
            <button
              key={entry.code}
              type="button"
              className={`sf-searchbar__dialcode-option ${selected.code === entry.code ? 'sf-searchbar__dialcode-option--active' : ''}`}
              onClick={() => handleSelectCode(entry)}
            >
              <span className="sf-searchbar__dialcode-flag">{entry.flag}</span>
              <span className="sf-searchbar__dialcode-option-name">{entry.name}</span>
              <span className="sf-searchbar__dialcode-code">{entry.dialCode}</span>
            </button>
          ))}
        </div>,
        document.body
      )}

      {phoneError && ReactDOM.createPortal(
        <div
          className="sf-searchbar__field-error-text"
          style={{ position: 'fixed', zIndex: 999999, ...errorStyle }}
        >
          {PHONE_ERROR_MESSAGE}
        </div>,
        document.body
      )}
    </div>
  );
};

export default PhoneSegment;
